/* eslint-disable */
export default {
  cancel: 'Annuler',
  pmiChangeConfirmed: 'Modifier',
  pmiChangeConfirmTitle: 'Modifier les paramètres de réunion personnelle ?',
  pmiChangeConfirmContext:
    'La modification de ces paramètres affectera toutes les réunions qui utilisent votre ID ou nom de réunion personnelle, y compris celles que vous avez déjà programmées.',
  updatePassword: 'Mettre à jour le mot de passe',
} as const;

// @key: @#@"cancel"@#@ @source: @#@"Cancel"@#@
// @key: @#@"pmiChangeConfirmed"@#@ @source: @#@"Change"@#@
// @key: @#@"pmiChangeConfirmTitle"@#@ @source: @#@"Change Personal Meeting settings?"@#@
// @key: @#@"pmiChangeConfirmContext"@#@ @source: @#@"Changing these settings will affect all meetings that use your personal meeting ID or name, including those you've already scheduled"@#@
// @key: @#@"updatePassword"@#@ @source: @#@"Update password"@#@
